import { addMinutes, subMinutes } from 'date-fns';
import sign from 'jwt-encode';

/**
 * Only import `sign` from `jsonwebtoken` in node environment for tests
 * As it does not work in browser environment
 *
 * @returns
 */
const getMockToken = async (expired?: boolean) => {
  if (typeof crypto.subtle !== 'undefined') {
    return '';
  }

  return sign(
    {
      iss: 'https://idp.local',
      aud: 'api1',
      sub: '5be86359073c434bad2da3932222dabe',
      exp: expired ? subMinutes(new Date(), 2).getTime() / 1000 : addMinutes(new Date(), 2).getTime() / 1000,
      iat: 1654744737,
      jti: 'ca18173bd335a28f21337d4bb4299ac5',
      id: 'U12345',
    },
    'secret',
  );
};

const getMockJWTToken = async (payload: Record<string, unknown>): Promise<string> => {
  const jwt = sign(payload, 'secret');
  return jwt;
};

export { getMockJWTToken, getMockToken };
